<template>
    <dash
        icon="fa fa-users"
        titulo="EQUIPE DE APOIO"
        subTitulo="SGF"
        @click.native="$router.push({ name: 'Gerentes_Apoios' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
